




























































import { Component, Vue, Prop, Watch, Ref, Emit } from "vue-property-decorator";

@Component({
})
export default class VirtualScrollerTable extends Vue {

  @Prop({ default: () => [] }) readonly columns: Array<any>;
  @Prop({ default: () => [] }) readonly dataSource: Array<any>;


  @Prop({ default: null }) 
  numToleratedItems: Number = null;

  @Prop({ default: false }) 
  loading: Boolean = false;

  @Prop({ default: 48 }) 
  itemSize: Number;

  @Prop({ default: 48 }) 
  headHeight: Number;

  @Prop({ default: 1500 }) 
  tableWidth: Number;
  
  @Prop({ default: null }) 
  scrollWidth: Number;

  @Prop({ default: null }) 
  scrollHeight: Number;

  @Emit('scrollIndexChange')
  scrollIndexChange(state: any) {
    return state
  }

  @Emit('scroll')
  scroll(e: any) {
    return e
  }

  
  @Watch("dataSource")
  itemsChange(newValue, oldValue) {
    if (!oldValue || oldValue.length !== (newValue || []).length) {
        this.init();
    }
  }

  isVertical() {
      return true;
  }
  
  private get element():HTMLElement{
    return this.$refs.elementRef as HTMLElement;
  }

  private get content(){
    return this.$refs.contentRef
  }

  public first:Number| any = 0;
  public last:Number| any = 0;
  public lastScrollPos:Number| any = 0;
  public numItemsInViewport:Number| any = 0;
  public d_numToleratedItems = this.numToleratedItems;
  public d_loading = this.loading;
  public contentStyle: any = {};
  public spacerStyle: any = {};
  public loaderArr: Array<any>=[];


  public get loadedItems(){
    const items = this.dataSource;
    if (items && !this.d_loading) {
         return items.slice(this.first, this.last);   
    }
    return [];
  }

  public get contentClass() {
      return ['p-virtualscroller-content', {
          'p-virtualscroller-loading': this.d_loading
      }];
  }

  public get loaderClass() {
      return ['p-virtualscroller-loader', {
          'p-component-overlay': !this.$slots.loader
      }];
  }

  public get fixedColumns(){
    return this.columns.filter(c=>c.fixed);
  }

  public get noFixedColumns(){
    return this.columns.filter(c=>!c.fixed);
  }

  public get containerClass() {
      return ['p-virtualscroller', {
          'p-both-scroll': false,
          'p-horizontal-scroll': false
      }, null];
  }

  public get headHeightStyle(){
    return {
      'height': `${this.headHeight}px`
    }
  }

  public get rowHeightStyle(){
    return {
      'height': `${this.itemSize}px`
    }
  }

  public get bodyStyle(){
    return {
      top: `${this.headHeight}px`,
      width: `${this.tableWidth}px`
    }
  }

  public get tableStyle(){
    return {
      width: `${this.tableWidth}px`
    }
  }

  public mounted() {
    this.init();
    this.lastScrollPos =  0;
  }

   public init(){
    this.setSize();
    this.calculateOptions();
    this.setSpacerSize();
  }

  
    setSpacerSize() {
      const items = this.dataSource;
      if (items) {
          const contentPos = this.getContentPosition();
          const setProp = (_name, _value, _size, _cpos = 0) => this.spacerStyle = { ...this.spacerStyle, ...{ [`${_name}`]: (((_value || []).length * _size) + _cpos) + 'px' } };
          setProp('height', items, this.itemSize, contentPos.y);
      }
    }


  calculateOptions() {
      const first = this.first;
      const { numItemsInViewport, numToleratedItems } = this.calculateNumItems();
      const calculateLast = (_first, _num, _numT, _isCols=false) => this.getLast(_first + _num + ((_first < _numT ? 2 : 3) * _numT), _isCols);
      const last = calculateLast(first, numItemsInViewport, numToleratedItems);
      this.last = last;
      this.numItemsInViewport = numItemsInViewport;
      this.d_numToleratedItems = numToleratedItems as Number;
      this.$emit('update:numToleratedItems', this.d_numToleratedItems);
  }


  calculateNumItems() {
        
        const itemSize = this.itemSize;
        const contentPos = this.getContentPosition();
        const contentWidth = this.element ? this.element.offsetWidth - contentPos.left : 0;
        const contentHeight = this.element ? this.element.offsetHeight - contentPos.top : 0;
        const calculateNumItemsInViewport = (_contentSize, _itemSize) => Math.ceil(_contentSize / (_itemSize || _contentSize));
        const calculateNumToleratedItems = (_numItems) => Math.ceil(_numItems / 2);
        const numItemsInViewport = 
            calculateNumItemsInViewport((contentHeight), itemSize);
        const numToleratedItems = this.d_numToleratedItems || (
            calculateNumToleratedItems(numItemsInViewport));
        return { numItemsInViewport, numToleratedItems };
    }

  
  setSize() {
      if (this.element) {
          const parentElement = (this.element).parentElement;
          const width = this.scrollWidth || `${(this.element.offsetWidth || parentElement.offsetWidth)}px`;
          const height = this.scrollHeight || `${(this.element.offsetHeight || parentElement.offsetHeight)}px`;
          const setProp = (_name, _value) => this.element.style[_name] = _value;
          setProp('height', height);
      }
  }

  public onScroll(event){
    this.scroll(event);
    this.onScrollChange(event);
  }


  setContentPosition(pos) {
      if (this.content) {
          
          const first = pos ? pos.first : this.first;
          const calculateTranslateVal = (_first, _size) => (_first * _size);
          const setTransform = (_x = 0, _y = 0) => {
              this.contentStyle = { ...this.contentStyle, ...{ transform: `translate3d(${_x}px, ${_y}px, 0)` } };
          };
          const translateVal = calculateTranslateVal(first, this.itemSize);
               setTransform(0, translateVal);
      }
  }

  
  onScrollChange(event) {
      const { first, last, isRangeChanged, scrollPos } = this.onScrollPositionChange(event);
      if (isRangeChanged) {
          const newState = { first, last };
          this.setContentPosition(newState);
          this.first = first;
          this.last = last;
          this.lastScrollPos = scrollPos;
          this.scrollIndexChange(newState);
      }
  }

  
  onScrollPositionChange(event) {
    const target = event.target;
    const contentPos = this.getContentPosition();
    const calculateScrollPos = (_pos, _cpos) => _pos ? (_pos > _cpos ? _pos - _cpos : _pos) : 0;
    const calculateCurrentIndex = (_pos, _size) => Math.floor(_pos / (_size || _pos));
    const calculateTriggerIndex = (_currentIndex, _first, _last, _num, _numT, _isScrollDownOrRight) => {
        return (_currentIndex <= _numT ? _numT : (_isScrollDownOrRight ? (_last - _num - _numT) : (_first + _numT - 1)))
    };
    const calculateFirst = (_currentIndex, _triggerIndex, _first, _last, _num, _numT, _isScrollDownOrRight) => {
        if (_currentIndex <= _numT)
            return 0;
        else
            return Math.max(0, _isScrollDownOrRight ?
                    (_currentIndex < _triggerIndex ? _first : _currentIndex - _numT) :
                    (_currentIndex > _triggerIndex ? _first : _currentIndex - (2 * _numT)));
    };

    const calculateLast = (_currentIndex, _first, _last, _num, _numT, _isCols=false) => {
        let lastValue = _first + _num + (2 * _numT);
        if (_currentIndex >= _numT) {
            lastValue += (_numT + 1);
        }
        return this.getLast(lastValue, _isCols);
    };

    const scrollTop = calculateScrollPos(target.scrollTop, contentPos.top);
    const scrollLeft = calculateScrollPos(target.scrollLeft, contentPos.left);
    let newFirst = 0;
    let newLast = this.last;
    let isRangeChanged = false;
    let newScrollPos = this.lastScrollPos;
    const scrollPos = scrollTop;
    const isScrollDownOrRight = this.lastScrollPos <= scrollPos;
    const currentIndex = calculateCurrentIndex(scrollPos, this.itemSize);
    const triggerIndex = calculateTriggerIndex(currentIndex, this.first, this.last, this.numItemsInViewport, this.d_numToleratedItems, isScrollDownOrRight);
    newFirst = calculateFirst(currentIndex, triggerIndex, this.first, this.last, this.numItemsInViewport, this.d_numToleratedItems, isScrollDownOrRight);
    newLast = calculateLast(currentIndex, newFirst, this.last, this.numItemsInViewport, this.d_numToleratedItems);
    isRangeChanged = newFirst !== this.first || newLast !== this.last;
    newScrollPos = scrollPos;
    return {
        first: newFirst,
        last: newLast,
        isRangeChanged,
        scrollPos: newScrollPos
    }
  }

  
  getLast(last = 0, isCols) {
      if (this.dataSource) {
          return Math.min((isCols ? (this.columns || this.dataSource[0]).length : this.dataSource.length), last);
      }
      return 0;
  }
  getContentPosition() {
      if (this.content) {
          const style = getComputedStyle(this.content as Element);
          const left = parseInt(style.paddingLeft, 10) + Math.max(parseInt(style.left, 10), 0);
          const right = parseInt(style.paddingRight, 10) + Math.max(parseInt(style.right, 10), 0);
          const top = parseInt(style.paddingTop, 10) + Math.max(parseInt(style.top, 10), 0);
          const bottom = parseInt(style.paddingBottom, 10) + Math.max(parseInt(style.bottom, 10), 0);
          return { left, right, top, bottom, x: left + right, y: top + bottom };
      }
      return { left: 0, right: 0, top: 0, bottom: 0, x: 0, y: 0 };
  }

}
